export const dateFormat = 'dd-MM-yyyy';
export const dateTimeFormat = 'dd-MM-yyyy hh:mm:ss a';
export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const idleTimeOut = DAY;
// export const idleTimeOut = 5 * 60 * 1000
export const logoutTimeAfterModal = 1 * MINUTE;

export const WEBSOCKET_SUPPORTED = `${process.env.REACT_APP_WEBSOCKET_SUPPORTED}` === 'true';

export const ZIGGEO_API_KEY = `${process.env.REACT_APP_ZIGGEO_API_KEY}`;

export const ZIGGEO_BASE_URL = `${process.env.REACT_APP_ZIGGEO_BASE_URL}`;
export const FEATURE_FLAG = {
    CUSTOMER_SUPPORT_ENABLED: "DVC-360-CUSTOMER-SUPPORT-ENABLED",
}
